export const ADD_TO_STACK_AJAX = 'ADD_TO_STACK_AJAX';
export const REMOVE_FROM_STACK_AJAX = 'REMOVE_FROM_STACK_AJAX';



// WEBPACK FOOTER //
// ./src/store/reducers/ajaxCall/actionTypes.js